module.exports = __webpack_public_path__ + "static/media/opensource.13314226.png";